(($) => {

    $.fn.listEditor = function () {
        /*
        Enables an input to manage the elements of a list
        */

        const addButtons = $('[data-list-editor="add"]');

        try {
            addButtons.each((i, el) => {
                const addButton = $(el);
                const sourceId = addButton.data('source');

                if (!sourceId) {
                    throw new Error('missing source id');
                }
                const targetId = addButton.data('target');
                if (!targetId) {
                    throw new Error('missing target id');
                }
                const inputName = addButton.data('inputName');
                if (!inputName) {
                    throw new Error('missing data-input-name attribute');
                }
                const sourceInput = $('#' + sourceId);
                if (sourceInput.length === 0) {
                    throw new Error('cannot find source input');
                }
                const targetList = $('#' + targetId);
                if (targetList.length === 0) {
                    throw new Error('cannot find target input');
                }

                // disable add button to prevent empty input from being added to the list
                if (sourceInput.val() === '') {
                    addButton.attr('disabled', 'disabled');
                }

                // handle click on add button by taking input value and appending it to the list
                addButton.on('click', event => {
                    event.preventDefault();
                    const value = sourceInput.val();
                    const listItem = targetList.find('.managed-list-item:first-child').clone();
                    listItem.find('.managed-list-value').text(value);
                    listItem.find('[data-list-editor="remove"]').on('click', event => {
                        event.preventDefault();
                        const target = $(event.target);
                        target.closest('.managed-list-item').remove();
                    });
                    const hiddenInput = $('<input type="hidden"/>');
                    hiddenInput.attr('name', inputName);
                    hiddenInput.val(value);
                    listItem.append(hiddenInput);
                    targetList.append(listItem);

                    sourceInput.val('');
                    addButton.attr('disabled', 'disabled');
                    sourceInput.focus();
                });

                // re-enable add button if ever input becomes non-empty
                $(sourceInput).keyup(function(){
                    if (sourceInput.val() === '') {
                        addButton.attr('disabled', 'disabled');
                    }
                    else {
                        addButton.removeAttr('disabled');
                    }
                });
            });
        }
        catch (e) {
            console.error('List Editor Plugin Error: ', e.message);
        }
    };

})(jQuery);
